import { Layout } from '@/views/account';

export default {
    path: '/account',
    component: Layout,
    children: [
        { path: 'login', component: () => import('@/views/account/Login.vue') }
    ]
};
